import Logo from '../images/Logo.jsx';
import splash_diamond from '../../resources/images/splash_diamond.png';

const Splash = () => {
    return (
        <div className='flex justify-center items-center h-screen bg-splash bg-center bg-cover'>
            <div className='flex flex-col justify-center items-center'>
                <Logo className='w-60 fill-current text-theme1-white mb-40' />
                <img alt='AI' src={splash_diamond} className='w-44 h-44' />
            </div>
        </div>
    );
};

export default Splash;
